import { useState, useRef, useEffect } from 'react'
import { useGameStore } from '../stores/gameStore'
import { useAuthStore } from '../stores/authStore'
import { useInstallPrompt } from '../hooks/useInstallPrompt'
import './TopBar.css'

export function TopBar() {
  const { gameDate, resources } = useGameStore()
  const { user, logout } = useAuthStore()
  const { isInstallable, isInstalled, promptInstall } = useInstallPrompt()
  const [showUserMenu, setShowUserMenu] = useState(false)
  const [showInstallToast, setShowInstallToast] = useState(false)
  const menuRef = useRef<HTMLDivElement>(null)

  // 显示安装提示
  useEffect(() => {
    if (isInstallable && !isInstalled) {
      const timer = setTimeout(() => {
        setShowInstallToast(true)
      }, 3000)
      return () => clearTimeout(timer)
    }
  }, [isInstallable, isInstalled])

  const formatYear = (year: number) => {
    if (year < 0) return `公元前${Math.abs(year)}年`
    return `公元${year}年`
  }

  // 点击外部关闭菜单
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setShowUserMenu(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  const handleLogout = async () => {
    await logout()
    setShowUserMenu(false)
  }

  // 获取用户头像首字母
  const getAvatarLetter = () => {
    if (!user?.email) return '?'
    return user.email.charAt(0).toUpperCase()
  }

  return (
    <div className="top-bar">
      <div className="top-bar-left">
        <div className="game-title">
          <h1>华夏志</h1>
        </div>
      </div>
      
      <div className="game-date">
        <span className="date-display">
          {formatYear(gameDate.year)} · {gameDate.month}月
        </span>
      </div>
      
      <div className="top-bar-right">
        <div className="resources">
          <div className="resource-item">
            <span className="resource-icon">🌾</span>
            <span className="resource-value">{resources.food}</span>
          </div>
          <div className="resource-item">
            <span className="resource-icon">💰</span>
            <span className="resource-value">{resources.money}</span>
          </div>
          <div className="resource-item">
            <span className="resource-icon">👥</span>
            <span className="resource-value">{resources.population}</span>
          </div>
          <div className="resource-item">
            <span className="resource-icon">🏆</span>
            <span className="resource-value">{resources.prestige}</span>
          </div>
        </div>

        {/* 用户头像下拉菜单 */}
        {user && (
          <div className="user-menu-container" ref={menuRef}>
            <button 
              className="user-avatar-btn"
              onClick={() => setShowUserMenu(!showUserMenu)}
            >
              <div className="user-avatar">{getAvatarLetter()}</div>
            </button>
            
            {showUserMenu && (
              <div className="user-dropdown-menu">
                <div className="user-dropdown-header">
                  <span className="user-email">{user.email}</span>
                </div>
                <div className="user-dropdown-divider"></div>
                <button className="user-dropdown-item" onClick={() => setShowUserMenu(false)}>
                  <span className="dropdown-icon">👤</span>
                  <span>账号详情</span>
                </button>
                <button className="user-dropdown-item logout" onClick={handleLogout}>
                  <span className="dropdown-icon">🚪</span>
                  <span>退出登录</span>
                </button>
                {/* 安装应用按钮 */}
                {isInstallable && !isInstalled && (
                  <>
                    <div className="user-dropdown-divider"></div>
                    <button className="user-dropdown-item install" onClick={() => { promptInstall(); setShowUserMenu(false); }}>
                      <span className="dropdown-icon">📱</span>
                      <span>安装应用</span>
                    </button>
                  </>
                )}
              </div>
            )}
          </div>
        )}
      </div>

      {/* 安装提示 Toast */}
      {showInstallToast && (
        <div className="install-toast">
          <div className="install-toast-content">
            <span className="install-toast-text">📱 添加到主屏幕，获得全屏体验</span>
            <div className="install-toast-actions">
              <button className="install-toast-btn install" onClick={() => { promptInstall(); setShowInstallToast(false); }}>
                安装
              </button>
              <button className="install-toast-btn dismiss" onClick={() => setShowInstallToast(false)}>
                稍后
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
